export const FILE_COLLECTION = 'file-metadata';



// WEBPACK FOOTER //
// ./src/js/files/domain/config.js